/**
 * Article Web Components — Rodhouse
 * Composants réutilisables dans le rich text des articles de blog.
 * Chargé une fois via layout/theme.liquid (components.js).
 *
 *   <rh-subtitle data-number="01" data-kicker="Bien choisir" data-heading="Le choix du leurre"></rh-subtitle>
 *   <rh-product  data-handle="ma-canne" data-layout="row" data-rating="auto" data-cta="Découvrir"></rh-product>
 *   <rh-quote    data-author="L'équipe Rodhouse">Un bon leurre ne se choisit pas au hasard…</rh-quote>
 *
 * Aucune dépendance (pas d'OLD_*). Light DOM pour SEO + héritage du CSS thème.
 * Fallback : si l'éditeur Shopify strippe les balises custom, on upgrade aussi
 * les <div data-rh="product|subtitle|quote"> équivalents.
 */
(function () {
  'use strict';

  if (window.__rhComponentsInit) return;
  window.__rhComponentsInit = true;

  var STAR_PATH =
    'M12 2l2.9 6.3 6.9.6-5.2 4.6 1.6 6.8L12 17.3 5.8 20.9l1.6-6.8L2.2 9.5l6.9-.6z';
  var starUid = 0;

  /* =====================================================================
     Helpers partagés
     ===================================================================== */

  // Coefficient de taxe exposé globalement par layout/theme.liquid (#taxcoefficient).
  function getTaxCoefficient() {
    var el = document.getElementById('taxcoefficient');
    if (!el) return 1;
    var v = parseFloat((el.textContent || '').trim());
    return isNaN(v) || v <= 0 ? 1 : v;
  }

  // Réplique du formatMoney de snippets-quick-add-modal.js.
  function formatMoney(cents) {
    var format =
      window.themeVariables &&
      window.themeVariables.settings &&
      window.themeVariables.settings.moneyFormat;
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, format);
    }
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return amount + ' €';
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function attr(el, name, fallback) {
    var v = el.getAttribute('data-' + name);
    return v == null || v === '' ? fallback : v;
  }

  // Étoile SVG : fill = 1 (pleine), 0.5 (moitié), 0 (vide).
  function starSVG(fill) {
    if (fill >= 1) {
      return (
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' +
        STAR_PATH +
        '" fill="currentColor"/></svg>'
      );
    }
    if (fill <= 0) {
      return (
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' +
        STAR_PATH +
        '" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>'
      );
    }
    var id = 'rhc-half-' + starUid++;
    return (
      '<svg viewBox="0 0 24 24" aria-hidden="true"><defs><linearGradient id="' +
      id +
      '"><stop offset="50%" stop-color="currentColor"/><stop offset="50%" stop-color="transparent"/></linearGradient></defs><path d="' +
      STAR_PATH +
      '" fill="url(#' +
      id +
      ')" stroke="currentColor" stroke-width="1.1"/></svg>'
    );
  }

  // Rend 5 étoiles selon une note (arrondi par paliers de 0.25, comme product-rating-stars.liquid).
  function starsMarkup(rating, count) {
    var stars = '';
    for (var i = 0; i < 5; i++) {
      var diff = rating - i;
      var fill = diff >= 0.75 ? 1 : diff >= 0.25 ? 0.5 : 0;
      stars += starSVG(fill);
    }
    var label = 'Note ' + (Math.round(rating * 10) / 10) + ' sur 5';
    var html =
      '<span class="rhc-stars" role="img" aria-label="' +
      escapeHtml(label) +
      '">' +
      stars +
      '</span>';
    if (count > 0) {
      html += '<span class="rhc-product__reviews">(' + count + ')</span>';
    }
    return html;
  }

  // URL image dimensionnée.
  function sizedImage(url, width) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  /* =====================================================================
     Récupération de la note Judge.me via le JSON-LD de la page produit
     (microdata-schema.liquid expose aggregateRating depuis
     product.metafields.reviews.rating, où Judge.me synchronise sa note).
     ===================================================================== */
  var ratingCache = {};
  function fetchRating(handle) {
    if (ratingCache[handle]) return ratingCache[handle];
    var p = fetch('/products/' + encodeURIComponent(handle))
      .then(function (r) {
        return r.ok ? r.text() : '';
      })
      .then(function (html) {
        if (!html) return null;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var scripts = doc.querySelectorAll('script[type="application/ld+json"]');
        for (var i = 0; i < scripts.length; i++) {
          var data;
          try {
            data = JSON.parse(scripts[i].textContent);
          } catch (e) {
            continue;
          }
          var nodes = Array.isArray(data)
            ? data
            : data['@graph'] || [data];
          for (var j = 0; j < nodes.length; j++) {
            var n = nodes[j];
            if (!n || !n.aggregateRating) continue;
            var t = n['@type'];
            var isProduct =
              t === 'Product' || (Array.isArray(t) && t.indexOf('Product') !== -1);
            if (!isProduct) continue;
            var value = parseFloat(n.aggregateRating.ratingValue);
            var count = parseInt(n.aggregateRating.reviewCount, 10) || 0;
            if (!isNaN(value)) return { value: value, count: count };
          }
        }
        return null;
      })
      .catch(function () {
        return null;
      });
    ratingCache[handle] = p;
    return p;
  }

  /* =====================================================================
     Renderers (partagés entre custom elements et fallback <div data-rh>)
     ===================================================================== */

  function renderSubtitle(el) {
    if (el._rhcDone) return;
    el._rhcDone = true;

    var accent = attr(el, 'accent', null);
    if (accent) el.style.setProperty('--rhc-accent', accent);

    var number = attr(el, 'number', '');
    var kicker = attr(el, 'kicker', '');
    var heading = attr(el, 'heading', el.textContent.trim());

    var top = '';
    if (number) {
      top += '<span class="rhc-subtitle__num">' + escapeHtml(number) + '</span>';
    }
    if (kicker) {
      top +=
        '<span class="rhc-subtitle__kicker">' + escapeHtml(kicker) + '</span>';
    }

    var html = '<div class="rhc-subtitle">';
    if (top) html += '<div class="rhc-subtitle__top">' + top + '</div>';
    if (heading) {
      html +=
        '<h2 class="rhc-subtitle__heading">' + escapeHtml(heading) + '</h2>';
    }
    html += '</div>';
    el.innerHTML = html;
  }

  function renderQuote(el) {
    if (el._rhcDone) return;
    el._rhcDone = true;

    var accent = attr(el, 'accent', null);
    if (accent) el.style.setProperty('--rhc-accent', accent);

    // Le texte de la phrase = contenu enfant (préserve <strong>/<em>).
    var inner = el.innerHTML.trim();
    var cite = attr(el, 'author', attr(el, 'cite', ''));

    var html = '<blockquote class="rhc-quote">' + inner;
    if (cite) {
      html += '<cite class="rhc-quote__cite">' + escapeHtml(cite) + '</cite>';
    }
    html += '</blockquote>';
    el.innerHTML = html;
  }

  function renderProduct(el) {
    if (el._rhcDone) return;
    el._rhcDone = true;

    var accent = attr(el, 'accent', null);
    if (accent) el.style.setProperty('--rhc-accent', accent);

    var handle = attr(el, 'handle', null);

    // Skeleton de chargement.
    el.classList.add('rhc-ready');
    el.innerHTML =
      '<div class="rhc-product rhc-product--loading">' +
      '<div class="rhc-product__media"><div class="rhc-product__img rhc-skeleton"></div></div>' +
      '<div class="rhc-product__body">' +
      '<div class="rhc-skeleton" style="height:12px;width:40%"></div>' +
      '<div class="rhc-skeleton" style="height:20px;width:80%"></div>' +
      '<div class="rhc-skeleton" style="height:24px;width:50%"></div>' +
      '</div></div>';

    if (handle) {
      fetch('/products/' + encodeURIComponent(handle) + '.js', {
        headers: { Accept: 'application/json' },
      })
        .then(function (r) {
          if (!r.ok) throw new Error('not found');
          return r.json();
        })
        .then(function (data) {
          paintProduct(el, {
            handle: handle,
            title: data.title,
            brand: data.vendor,
            image: data.featured_image,
            url: data.url,
            price: data.price,
            compareAt: data.compare_at_price,
            available: data.available,
          });
        })
        .catch(function () {
          // Produit introuvable : on retire proprement le composant.
          el.innerHTML = '';
          el.style.display = 'none';
        });
    } else {
      // Mode manuel (sans handle) : on lit les attributs.
      var price = parseInt(attr(el, 'price', ''), 10);
      paintProduct(el, {
        handle: null,
        title: attr(el, 'title', ''),
        brand: attr(el, 'brand', ''),
        image: attr(el, 'image', ''),
        url: attr(el, 'href', '#'),
        price: isNaN(price) ? null : price,
        compareAt: null,
        available: true,
      });
    }
  }

  function paintProduct(el, p) {
    var coeff = getTaxCoefficient();
    var layout = attr(el, 'layout', 'row');
    el.setAttribute('data-layout', layout);

    var href = attr(el, 'href', p.url || '#');

    // Prix TTC.
    var priceHtml = '';
    if (p.price != null) {
      var priceTTC = Math.round(p.price * coeff);
      priceHtml +=
        '<span class="rhc-product__price">' + formatMoney(priceTTC) + '</span>';
      if (p.compareAt && p.compareAt > p.price) {
        var compareTTC = Math.round(p.compareAt * coeff);
        priceHtml +=
          '<span class="rhc-product__compare">' +
          formatMoney(compareTTC) +
          '</span>';
      }
    }

    // Badge promo.
    var badge = attr(el, 'badge', '');
    if (!badge && p.compareAt && p.compareAt > p.price) {
      badge = '−' + Math.round((1 - p.price / p.compareAt) * 100) + ' %';
    }
    var badgeHtml = badge
      ? '<span class="rhc-product__badge">' + escapeHtml(badge) + '</span>'
      : '';

    var imgHtml = p.image
      ? '<img class="rhc-product__img" src="' +
        escapeHtml(sizedImage(p.image, 400)) +
        '" alt="' +
        escapeHtml(p.title) +
        '" loading="lazy" width="300" height="300">'
      : '<div class="rhc-product__img"></div>';

    var cta = attr(el, 'cta', 'Voir le produit');

    el.innerHTML =
      '<div class="rhc-product"' +
      (p.available ? '' : ' aria-disabled="true"') +
      '>' +
      '<div class="rhc-product__media">' +
      imgHtml +
      badgeHtml +
      '</div>' +
      '<div class="rhc-product__body">' +
      '<h3 class="rhc-product__title">' +
      escapeHtml(p.title) +
      '</h3>' +
      '<div class="rhc-product__rating" hidden></div>' +
      '<div class="rhc-product__footer">' +
      '<div class="rhc-product__prices">' +
      priceHtml +
      '</div>' +
      '<a class="rhc-product__cta" href="' +
      escapeHtml(href) +
      '" target="_blank" rel="noopener">' +
      escapeHtml(cta) +
      '</a>' +
      '</div>' +
      '</div>' +
      '</div>';

    // Étoiles.
    var ratingAttr = attr(el, 'rating', '');
    var ratingBox = el.querySelector('.rhc-product__rating');
    if (ratingAttr === 'auto' && p.handle) {
      fetchRating(p.handle).then(function (res) {
        if (res && res.value > 0 && ratingBox) {
          ratingBox.innerHTML = starsMarkup(res.value, res.count);
          ratingBox.hidden = false;
        }
      });
    } else if (ratingAttr && ratingAttr !== 'auto') {
      var val = parseFloat(ratingAttr);
      if (!isNaN(val) && ratingBox) {
        var count = parseInt(attr(el, 'reviews', '0'), 10) || 0;
        ratingBox.innerHTML = starsMarkup(val, count);
        ratingBox.hidden = false;
      }
    }
  }

  /* =====================================================================
     Définition des custom elements
     ===================================================================== */
  function defineEl(tag, renderer, waitForChildren) {
    if (!window.customElements || customElements.get(tag)) return;
    customElements.define(
      tag,
      class extends HTMLElement {
        connectedCallback() {
          // Si l'élément a des enfants (ex: la phrase de <rh-quote>) et que le
          // document est encore en cours de parsing, connectedCallback peut se
          // déclencher avant que les enfants soient disponibles → on attend.
          if (waitForChildren && document.readyState === 'loading') {
            document.addEventListener(
              'DOMContentLoaded',
              renderer.bind(null, this),
              { once: true }
            );
          } else {
            renderer(this);
          }
        }
      }
    );
  }

  defineEl('rh-subtitle', renderSubtitle);
  defineEl('rh-quote', renderQuote, true);
  defineEl('rh-product', renderProduct);

  /* =====================================================================
     Fallback : <div data-rh="subtitle|quote|product"> si les balises
     custom ont été strippées par l'éditeur Shopify.
     ===================================================================== */
  function upgradeFallbacks() {
    document.querySelectorAll('[data-rh="subtitle"]').forEach(renderSubtitle);
    document.querySelectorAll('[data-rh="quote"]').forEach(renderQuote);
    document.querySelectorAll('[data-rh="product"]').forEach(renderProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', upgradeFallbacks);
  } else {
    upgradeFallbacks();
  }
})();
